var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getState } from './helpers';
import { resolveEffectiveUiTokens } from './nodeTheme';
import { runWithCanvasUiTheme, syncActiveCanvasUiTheme } from './resolveCanvasTheme';
/** Compound canvas widgets whose listeners live on children — safe to wipe+rebuild chrome. */
export var UI_REBUILD_TYPES = new Set([
    'tabs',
    'accordion',
    'table',
    'tree',
    'toolbar',
]);
/**
 * Attach rebuild so setUiTheme can recreate compound chrome without replacing the root node.
 * Child listeners are re-wired by the factory; root identity (and user root listeners) stay.
 */
export function installUiRebuild(group, app, factory) {
    var rebuild = function () {
        var props = __assign(__assign({}, getState(group)), { x: group.x, y: group.y });
        var theme = syncActiveCanvasUiTheme(resolveEffectiveUiTokens(app, props), app);
        runWithCanvasUiTheme(theme, function () {
            var e_1, _a, e_2, _b;
            var _c, _d;
            try {
                for (var _e = __values(__spreadArray([], __read(group.children), false)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var child = _f.value;
                    group.remove(child);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // Drop root listeners the factory will re-attach on a throwaway group;
            // child-level handlers move with transferred children.
            var fresh = factory(props, app);
            if (!fresh || !('children' in fresh))
                return;
            try {
                for (var _g = __values(__spreadArray([], __read(fresh.children), false)), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var child = _h.value;
                    fresh.remove(child);
                    group.add(child);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_2) throw e_2.error; }
            }
            group.metadata._parts = fresh.metadata._parts;
            group.metadata.componentState = __assign(__assign({}, getState(group)), ((_d = (_c = fresh.metadata) === null || _c === void 0 ? void 0 : _c.componentState) !== null && _d !== void 0 ? _d : {}));
        });
        app.requestRender();
    };
    group.metadata.uiRebuild = rebuild;
}
export function runUiRebuild(node) {
    var _a;
    var rebuild = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.uiRebuild;
    if (typeof rebuild !== 'function')
        return false;
    rebuild();
    return true;
}
